import { render, staticRenderFns } from "./Opportunite.vue?vue&type=template&id=5293db14&"
import script from "./Opportunite.vue?vue&type=script&lang=js&"
export * from "./Opportunite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports